
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="row">
    <v-btn @click="$router.go(-1)" outlined style="border: none;margin: 20px" title="Retour"><v-icon>mdi mdi-arrow-left</v-icon></v-btn>
    <div class="col-12 mb-4">
      <v-card>
        <v-tabs  v-model="tabs" color="#1C3071" grow >
          <v-tab  style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
            <v-icon >mdi-account-cog</v-icon>
            <span style="margin-left: 5%"></span>
            {{$t('reversements.configs_palier')}}
          </v-tab>
          <v-tab style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
            <v-icon>mdi-account-group</v-icon>
            <span style="margin-left: 5%"></span>
            {{$t('reversements.configs_periode')}}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <!--PALIER CONFIGS-->
          <v-tab-item>
            <v-card flat>
              <palier-reversement-configs></palier-reversement-configs>
            </v-card>
          </v-tab-item>
          <!--PERIODE CONFIGS-->
          <v-tab-item>
            <v-card flat>
              <periode-reversement-configs></periode-reversement-configs>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>

    </div>
  </div>

</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from "@/mixins/helpers";
    import PalierReversementConfigs
      from "@/components/administrators/components/reversements_perfoms/PalierReversementConfigs";
    import PeriodeReversementConfigs
      from "@/components/administrators/components/reversements_perfoms/PeriodeReversementConfigs";

    export default {
      components: {PeriodeReversementConfigs, PalierReversementConfigs},
      label: "ReversementConfigsAdmin",
      mixins:[helpers(this)],
        data() {
            return {
              tabs:null,

              submitting: false,

                valid: true,
                lazy: false,
                errors: undefined,
                errors_means: null,
                errors_montant: null,
                  dialogShowDetail:false,
                itemSteps: [
                    "Mois", "Trimestre", "Semestre"
                ],
                search: '',
                dialog: '',
                dialogNote: false,
                 note:"",
                id: undefined,
                step1: false,
                step2: false,
                step3: false,
                type: 'Mobile',
                e1: 1,
                detailuser: {},
                typesLists:['Mobile', 'Banque'],
                typesLists2:['bystep', 'byperiode'],
                headers: [
                    {
                        text: 'Source de réception',
                        align: 'start',
                        sortable: true,
                        value: '_usermeanspaiement._means_paiement',
                    },
                    {text: 'Type de la source', value: '_usermeanspaiement._means_paiement._type'},
                    {text: 'Numéro du compte', value: '_usermeanspaiement._account_number'},
                    {text: 'Montant', value: '_montant'},
                    {text: 'Période', value: '_periode'},
                    {text: 'Notification', value: '_send_mail'},
                    {text: 'Dernier reversement', value: '_last_reversement_date'},
                    {text: 'Date', value: '_created_at'},


                                    ],
                editedIndex: -1,
                editedItem: {
                    _type_transfert: 'bystep',
                    _montant: 1,
                    _periode: 'Mois',
                    _send_mail: '',
                    _marchand: '',
                    _usermeanspaiement: '',
                    _type_means: 'Mobile',
                    _id: 0,
                    _created_at: 0,
                },
                defaultItem: {
                  _type_transfert: 'bystep',
                  _montant: 1,
                  _periode: 'Mois',
                  _send_mail: '',
                  _marchand: '',
                  _usermeanspaiement: '',
                  _type_means: 'Mobile',
                  _id: 0,
                  _created_at: 0,
                },
                periodeRules: [
                    v => !!v || 'Période requise',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                type_transfertRules: [
                    v => !!v || 'Type requis',
                ]
                ,
                montantRules: [
                    v => !!v || 'Montant requis',
                ],
                usermeanspaiementRules: [
                    v => !!v || 'Moyen de paiement requis',
                ]

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.$t('reversements.newtext') : this.$t('reversements.update')
            }
            ,
            ...mapState('reversements/', ['reversements_configs']),

        }
        ,
        mounted() {

            this.$store.dispatch('reversements/getReversementConfigsForAdmin').then(response => {});

        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            },
            userDetail(item){
              this.detailuser = item._marchand;
              this.dialogShowDetail = true;
              console.log("this.detailuser",this.detailuser);

            },
             shownote(vnote){
                this.note = vnote;
                this.dialogNote = true;
            },
            closeNote(){
                this.note = "Vide";
                 this.dialogNote = false;
            },

            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            fileChange() {
                console.log(this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file) {
                return file.substr(file.lastIndexOf('/') + 1)
            },
            checkIfExist() {
                let VueBox = this;
                if (VueBox.editedIndex > -1) {
                    return VueBox.values.find(value => value._code === VueBox.editedItem.code && value._id !== VueBox.editedItem._id)
                } else {
                    return VueBox.values.find(value => value._code === VueBox.editedItem.code)
                }
            }
            ,
            getColor(calories) {
              if (calories == "Banque") return 'green'
              else if (calories == "Mobile") return 'orange'
              else return 'green'
            },
            getColor2(calories) {
                if (calories == "en_attente") return 'orange'
                else if (calories == "success") return 'green'
                else return 'red'
            }
        }
        ,
        created() {
            this.checkisDashboard();
            this.initialize()
        }
    }
</script>

<style scoped>

</style>
